import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

import { AuthContext } from "../../../shared/context/auth-context";
import "../../../shared/css/lists.scss";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import DatatableTratamentoViewOnly from "../components/datatable/DatatableTratamentoViewOnly";

function AgendamentosTratamentoViewOnly() {
  const [medicos, setMedicos] = useState();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const { sendRequest } = useHttpClient();

  const medicosAssociados =
    auth.role === "Secretária(o)" || auth.role === "Assistente"
      ? auth.usuariosAssociados
      : null;

  useEffect(() => {
    const fetchMedicos = async () => {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        const temp = [];
        response.users.forEach((u) => {
          if (
            u.role.role === "Dentista" ||
            u.role.role === "Médico/Administrador"
          ) {
            temp.push({ ...u, nome: u.name });
          }
        });
        setMedicos(temp);
      } catch (err) {}
    };

    if (auth.role === "Médico/Administrador" || auth.role === "Gerente") {
      fetchMedicos();
    }
  }, [auth.token, clinica.clinica._id, sendRequest]);

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        {/* A lista que esta página usa é `medicosAssociados || medicos`, e a
            condição tem de olhar para a MESMA.

            Olhava só para `medicos`, que é preenchido pelo `fetchMedicos()` —
            e esse só corre para Médico/Administrador e Gerente. Uma assistente,
            que é quem o menu manda para aqui, ficava com `medicos` indefinido e
            a página não desenhava nada: barra lateral e mais nada.

            A variante da agenda normal não tem esta condição e por isso nunca
            sofreu do problema; era só a de tratamentos. */}
        {(medicosAssociados || medicos) && (
          <>
            <Navbar
              title="Agendamentos"
              icon={CalendarMonthOutlinedIcon}
              medicos={medicosAssociados || medicos}
            />
            <DatatableTratamentoViewOnly
              medicos={medicosAssociados || medicos}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default AgendamentosTratamentoViewOnly;
